import type { TrackingLabels } from '@shared/tracking/TrackingLabels';
import type { NavigationHistory } from '@shared/types/History.ts';

export function getSelectionRulesTracking(
    rule: string,
    navigationHistory: NavigationHistory | null = null,
    navigationHistoryEnabled: boolean = false,
): Pick<TrackingLabels, 'wk.san_EntrySelectionRule' | 'wk.san_SelectionRule'> {
    const entryRule =
        navigationHistoryEnabled && navigationHistory
            ? navigationHistory.currentEntryRule(rule)
            : (window.history.state?.entryRule ?? rule);

    return {
        'wk.san_EntrySelectionRule': entryRule,
        'wk.san_SelectionRule': rule,
    };
}
